import axios from "axios"
import { api } from "./api"
const baseUrl = "/public/road"

export const searchRoad = (query: string) => {
    return api.get(`${baseUrl}/search?searchTerm=${query}`).then(res => res.data)
}

export const downloadRoadToExcel = (query: string) => {
    return axios
        .get(`/api/public/road/download?searchTerm=${query}`, {
            responseType: 'arraybuffer',
        })
        .then((res) => {
            const url = window.URL.createObjectURL(new Blob([res.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'report.xlsx');
            document.body.appendChild(link);
            link.click();
            link.remove();
        });
}
